import type { TaskStep } from "@/services/api/data-hub/types";

import { deriveItemGroupProgress, type ItemGroupTaskProgress } from "./itemGroupTaskProgress";

const ASSESS_RULES_STEP_LABEL = "Assess rules";

export type AssessmentTaskProgress = ItemGroupTaskProgress;

/** Derive rule assessment counts from runner task steps (Assess rules item group). */
export function deriveAssessmentTaskProgress(
  steps: TaskStep[],
  _overallProgress: number,
): AssessmentTaskProgress | null {
  return deriveItemGroupProgress(steps, ASSESS_RULES_STEP_LABEL, ({ processedCount, total }) => `Assess rules: ${processedCount}/${total}`);
}
